import { IPlacementsList } from '../AssetsManagement/types';
import { IconData, IconName } from '../../components/Icon/types';
import { iconMapKeys } from '.icons';

export interface CurationManagementState {
  loading: boolean;
  curationLoading: boolean;
  error?: string;
  clicks: any[];
  insights: any;
  placements: IPlacementsList;
  oldCurations: CurationType[];
  oldCuration: CurationType | null;
  oldCurationSubs: CurationType[];
  oldCurationSub: CurationType | null;
  qnas: QuestionAnswer[];
  curations: Curation[];
  curation: Curation | null;
  chapters: Chapter[];
  chapter: Chapter | null;
  chaptersLoading: boolean;
  chaptersError?: string | null;
  questionAnswers: QuestionAnswer[];
  simulateResult: SimulateQuestionForSocialFeedResponse | null;
  simulateResults: Record<string, SimulateQuestionForSocialFeedResponse>;
  simulateLoading: boolean;
}

export interface Curation {
  id?: string;
  title: string;
  placements: string[];
  purpose: CurationPurpose;
  dynamic: boolean;
  instruction?: string;
  type?: 'feed' | 'socialfeed';
}

export enum CurationPurpose {
  CONVERSION = 'CONVERSION',
  ENGAGEMENT = 'ENGAGEMENT',
  EDUCATION = 'EDUCATION'
}

export class Chapter {
  id?: string;
  title: string | undefined;
  type: ChapterTypes | undefined;
  curation?: string;
  cover?: string;
  files?: string[];
  qas?: QuestionAnswer[];
}

export enum ChapterTypes {
  PERSONA = 'PERSONA',
  SOURCE = 'SOURCE',
  LIFECYCLE = 'LIFECYCLE',
  PRODUCTS = 'PRODUCTS',
  CALENDAR = 'CALENDAR',
  GEOGRAPHY = 'GEOGRAPHY'
}

export class ChapterType {
  label: string;
  type: ChapterTypes;
  icon: IconName;
  backgroundColor: string;
  addPrompt: string;
  describePrompt: string;

  constructor(
    label: string,
    type: ChapterTypes,
    icon: IconName,
    backgroundColor: string,
    addPrompt: string,
    describePrompt: string
  ) {
    this.label = label;
    this.type = type;
    this.icon = icon;
    this.backgroundColor = backgroundColor;
    this.addPrompt = addPrompt;
    this.describePrompt = describePrompt;
  }
}

export const CHAPTER_TYPES: Record<ChapterTypes, ChapterType> = {
  [ChapterTypes.PERSONA]: {
    label: 'Persona',
    type: ChapterTypes.PERSONA,
    icon: 'document-text-linear',
    backgroundColor: '#833CE2',
    addPrompt: 'Add new Persona',
    describePrompt: 'Persona description'
  },
  [ChapterTypes.LIFECYCLE]: {
    label: 'Lifecycle',
    type: ChapterTypes.LIFECYCLE,
    icon: 'chart-reverse',
    backgroundColor: '#02C121',
    addPrompt: 'Add new Stage',
    describePrompt: 'Stage description'
  },
  [ChapterTypes.PRODUCTS]: {
    label: 'Products',
    type: ChapterTypes.PRODUCTS,
    icon: 'box-1-linear',
    backgroundColor: '#DD56BA',
    addPrompt: 'Add new Relationship',
    describePrompt: 'Relationship description'
  },
  [ChapterTypes.CALENDAR]: {
    label: 'Calendar',
    type: ChapterTypes.CALENDAR,
    icon: 'calendar-linear',
    backgroundColor: '#EB545A',
    addPrompt: 'Add new Event',
    describePrompt: 'Event description'
  },
  [ChapterTypes.GEOGRAPHY]: {
    label: 'Geography',
    type: ChapterTypes.GEOGRAPHY,
    icon: 'location-linear',
    backgroundColor: '#35D2C0',
    addPrompt: 'Add new Region',
    describePrompt: 'Region description'
  },
  [ChapterTypes.SOURCE]: {
    label: 'Source',
    type: ChapterTypes.SOURCE,
    icon: 'hierarchy-2-linear',
    backgroundColor: '#2E9EE4',
    addPrompt: 'Add new Source/UTM',
    describePrompt: 'Source description'
  }
};

export enum CurationTypes {
  PERSONA = 'persona',
  LIFE_CYCLE = 'lifecycle',
  CALENDAR = 'calendar',
  USER = 'user',
  PACKAGING = 'packaging',
  GEOGRAPHY = 'geography',
  CUSTOM = 'custom'
}

export enum ExperienceTypes {
  CURATION = 'curation',
  CAPTIVE_USERS = 'captive-users'
}

export enum DefaultCurationTypes {
  OVERVIEW = 'overview',
  VISION = 'vision',
  OPERATIONS = 'operations',
  RESOURCES = 'resources'
}

export interface CurationType {
  id?: string;
  title: string;
  description?: string;
  type: CurationTypes;
  icon?: iconMapKeys;
  color?: string;
  background?: string;
}

export interface ExperienceType {
  id?: string;
  title: string;
  description?: string;
  url: string;
  type: ExperienceTypes;
  icon?: iconMapKeys;
  color?: string;
  background?: string;
}

export interface QuestionAnswer {
  id?: string;
  question: string;
  answer: string;
  icon: IconData;
}

export interface EventType {
  page: string;
  event: string;
  timestamp: string;
}

export interface ThoughtsType {
  title: string;
  message?: string;
  tags?: string[];
}

export enum Statuses {
  DEFAULT = 'DEFAULT',
  EDIT = 'EDIT',
  CREATE = 'CREATE'
}

export const experienceTypesList: ExperienceType[] = [
  {
    title: 'Curation',
    description: 'Coach Curative AI in natural language',
    url: '/curations/create',
    type: ExperienceTypes.CURATION,
    icon: 'curation-border',
    color: '#833CE2',
    background: 'rgba(131, 60, 226, 0.10)'
  },
  {
    title: 'User Data',
    description: 'Connect a Postgres DB of your users',
    url: '/curations/create',
    type: ExperienceTypes.CAPTIVE_USERS,
    icon: 'people-linear',
    color: '#62C552',
    background: 'rgba(2, 193, 33, 0.10)'
  }
];

export interface PurposeBlockProps {
  title: string;
  description: string;
  icon: iconMapKeys;
  iconBackground?: string;
  boxSize?: string;
  iconColor?: string;
  selectable?: boolean;
  selected?: boolean;
  disabled?: boolean;
}

export interface ChapterProgressStep {
  title: string;
  description: string;
  icon: iconMapKeys;
  iconBackground: string;
}

export type FilterType = 'all' | 'feed' | 'socialfeed';

export interface SimulateQuestionForSocialFeedParams {
  curationId: string;
  chapterId: string;
  questionId: string;
}

export interface SimulateQuestionForSocialFeedResponse {
  id: string;
  result: any;
  endpoint?: string;
  questionId?: string;
}
